var path = 'app/scripts/modules/core/src/pipeline/config/stages/group/groupStage.html';
var html = "<div class=\"form-horizontal\">\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/core/src/pipeline/config/stages/group/groupStage.html
// module id = 1006
// module chunks = 0